import React from 'react';
import { Calendar } from '../components/journal/Calendar/Calendar';

const CalendarPage: React.FC = () => {
  return (
    <div className="relative min-h-screen overflow-hidden md:bg-transparent">
      {/* Atmospheric lighting - only visible on mobile */}
      <div className="md:hidden absolute top-0 right-0 w-[800px] h-[800px] rounded-full bg-primary-500/15 blur-[120px] -z-10"></div>
      <div className="md:hidden absolute bottom-0 left-0 w-[800px] h-[800px] rounded-full bg-gray-300/20 blur-[120px] -z-10"></div>
      
      <Calendar />
    </div>
  );
};

export default CalendarPage;